import { KnowlegeFile, FileClassifyItem } from './file';
import { KnowlegeFolder } from './folder';
/**
 * 平台知识库
 * 阿里知识库
 * 原料知识库
 * 用户共享知识库
 * 
 * 个人知识库
 * 企业知识库
 * 企业空间下的个人知识库
 */
// 知识库类型： 0：共享，1：平台，2：个人，3：产品，4：企业，5：企业成员 6：企业产品
export enum KnowledgeBaseLibType {
    /**
     * 用户共享知识库
     */
    UserShare = 0,
    /**
     * 平台知识库 阿里知识库  原料知识库等都属于平台知识库
     */
    Platform = 1,
    /**
     * 个人知识库
     */
    Personal = 2,
    /**
     * 产品知识库
     */
    Product = 3,
    /**
     * 企业知识库
     */
    Enterprise = 4,
    /**
     * 企业空间下的个人知识库
     */
    EnterprisePersonal = 5,
    /**
     * 企业产品知识库
     */
    EnterpriseProduct = 6,
    /**
     * 我的收藏
     */
    Collection = -1
}

/**
 * 知识库付费类型
 */
// 知识库付费标识：0普通（免费）、1：付费、2:限免
export enum KnowledgeBaseLibPayType {
    /**
     * 免费
     */
    Free = 0,
    /**
     * 付费
     */
    Pay = 1,
    /**
     * 限免
     */
    FreeLimit = 2
}

/**
 * 知识库排序类型
 */
export enum KnowlegeLibSortType {
    /**
     * 创建时间
     */
    UpdateTime = 0,
    /**
     * 按名称A-Z排序
     */
    NameAZ = 1,
    /**
     * 创建时间
     */
    CreateTime = 2
}



export type TableRow = KnowlegeFile | KnowlegeFolder | FileClassifyItem

// 全文摘要, 章节要点 提问场景推荐

export enum KnowledgeBaseLikeFiled {
    /**
     * 章节要点
     */
    ChapterDigestFavor = 0,
    /**
     * 全文摘要
     */
    FullDigestFavor = 1,
    /**
    * 文件夹摘要
    */
    FolderDigestFavor = 2,
    /**
     * 提问场景推荐
     */
    SuggestIssueFavor = 3,
}



export enum ListSelectType {
    ALL = 'ALL',
    CLASSIFIED = 'CLASSIFIED',
    UNCLASSIFIED = 'UNCLASSIFIED',
    COLLECTION = 'COLLECTION',
}